module.exports = __webpack_public_path__ + "static/img/neeNo.413dbffa.png";